import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Zap, Globe, Shield } from 'lucide-react';

const Landing = () => {
    return (
        <div className="min-h-screen bg-white flex flex-col">
            <nav className="container mx-auto px-6 py-5 flex justify-between items-center">
                {/* LOGO UPDATE */}
                <div className="text-2xl font-extrabold tracking-tight">
                    Auto<span className="text-primary">Inventor</span>
                </div>
                <div className="flex gap-4">
                    <Link to="/app/dashboard" className="text-slate-600 font-medium hover:text-primary py-2">
                        Open App
                    </Link>
                    <Link to="/app/dashboard" className="btn btn-primary rounded-full px-6">
                        Get Started
                    </Link>
                </div>
            </nav>

            <main className="flex-1">
                <section className="pt-20 pb-32 text-center px-6 max-w-5xl mx-auto">
                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-50 text-primary text-sm font-medium mb-8 border border-indigo-100 animate-fade-in">
                        <Zap size={14} fill="currentColor" /> AI Economy OS v1.0 Live
                    </div>
                    <h1 className="text-5xl md:text-7xl font-extrabold text-slate-900 tracking-tight mb-6 leading-tight animate-slide-up">
                        Turn your idea into a <br />
                        <span className="text-primary">Business Empire</span> instantly.
                    </h1>
                    <p className="text-xl text-slate-500 max-w-2xl mx-auto mb-10 animate-slide-up" style={{ animationDelay: '0.1s' }}>
                        {/* TEXT UPDATE */}
                        AutoInventor generates your branding, strategy, financial models, and legal structure.
                        You just give the command.
                    </p>
                    <div className="flex justify-center gap-4 animate-slide-up" style={{ animationDelay: '0.2s' }}>
                        <Link to="/app/dashboard" className="btn btn-primary px-8 py-4 text-lg rounded-full shadow-xl shadow-indigo-500/20">
                            Start Building Free <ArrowRight className="ml-2" />
                        </Link>
                        <button className="btn btn-secondary px-8 py-4 text-lg rounded-full">Watch Demo</button>
                    </div>

                    {/* Hero Mockup */}
                    <div className="mt-20 rounded-2xl border border-border shadow-2xl overflow-hidden animate-slide-up" style={{ animationDelay: '0.4s' }}>
                        <div className="bg-slate-50 border-b border-border p-4 flex gap-2">
                            <div className="w-3 h-3 rounded-full bg-red-400"></div>
                            <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                            <div className="w-3 h-3 rounded-full bg-green-400"></div>
                        </div>
                        <div className="bg-white p-8 h-64 md:h-96 flex items-center justify-center text-slate-300">
                            <div className="text-center">
                                <Globe size={48} className="mx-auto mb-4 text-slate-200" />
                                <p>AutoInventor Dashboard Interface</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-20 bg-slate-50">
                    <div className="container mx-auto px-6 grid md:grid-cols-3 gap-8">
                        {[
                            { icon: Zap, title: "Instant MVP", desc: "Generate landing pages and code in seconds." },
                            { icon: Globe, title: "Global Analysis", desc: "Real-time market data from 50+ countries." },
                            { icon: Shield, title: "Legal Ready", desc: "Auto-generated incorporation documents." }
                        ].map((f, i) => (
                            <div key={i} className="bg-white p-8 rounded-xl border border-border shadow-sm">
                                <div className="w-12 h-12 bg-indigo-50 rounded-lg flex items-center justify-center text-primary mb-4">
                                    <f.icon />
                                </div>
                                <h3 className="text-xl font-bold mb-2">{f.title}</h3>
                                <p className="text-slate-500">{f.desc}</p>
                            </div>
                        ))}
                    </div>
                </section>
            </main>
        </div>
    );
};
export default Landing;
